import common from '../../assets/utilits/common'

export default {
  namespaced: true,
  state: {

    graph_data_nodes: [
      // { id: '1', name: 'CDN', html:`<i style="font-size:40px" class="icon iconfont icon-CDN"'></i>` ,styleClass:'my-node-style', color: 'white', x: 0, y: 0, disableDefaultClickEffect:false, data: { name: 'CDN',icon:'icon iconfont icon-CDN' } },

      // { id: '2', name: '本地WAF', color: 'white', x: 0, y: 50, data: { name: '本地WAF' ,icon:'icon iconfont icon-yunWAF'} },
      // { id: '3', name: '阿里云WAF', color: 'white', x: 0, y: 100, data: { name: '阿里云WAF' ,icon:'icon iconfont icon-fanghuoqiang' } },
      // { id: '4', name: 'SLB', color: 'white', x: 0, y: 150, data: { name: 'SLB' ,icon:'icon iconfont icon-fuzaijunheng'} },
      // { id: '5', name: 'WEB服务器', color: 'white', x: 0, y: 200, data: { name: 'WEB服务器',icon:'icon iconfont icon-Web' } },
      // { id: '6', name: 'DB', color: 'white', x: 0, y: 250, data: { name: 'DB',icon:'icon iconfont icon-shujuguanli' } },
      // { id: '7', name: '自定义', color: 'white', x: 0, y: 300, data: { name: '自定义',icon:'icon iconfont icon-wenjianjia' } },
      // { id: '8', name: 'CDN', color: 'orange', x: 0, y: 0, data: { name: 'CDN' } },
      {
        id: '1',
        name: 'CDN',
        x: 0,
        y: 0,
        html: `<i style="font-size:60px;color:skyblue;" class="icon iconfont icon-CDN"></i>`
      },
      {
        id: '2',
        name: '本地WAF',
        x: 0,
        y: 70,
        html: `<i style="font-size:60px;color:skyblue;" class="icon iconfont icon-yunWAF"></i>`
      },
      {
        id: '3',
        name: '阿里云WAF',
        x: 0,
        y: 140,
        html: `<i style="font-size:60px;color:skyblue;" class="icon iconfont icon-fanghuoqiang"></i>`
      },
      {
        id: '4',
        name: 'SLB',
        x: 0,
        y: 210,
        html: `<i style="font-size:60px;color:skyblue;" class="icon iconfont icon-fuzaijunheng"></i>`
      },
      {
        id: '5',
        name: 'WEB服务器',
        x: 0,
        y: 280,
        html: `<i style="font-size:60px;color:skyblue;" class="icon iconfont icon-Web"></i>`
      },
      {
        id: '6',
        name: 'DB',
        x: 0,
        y: 350,
        html: `<i style="font-size:60px;color:skyblue;" class="icon iconfont icon-shujuguanli"></i>`
      },
      {
        id: '7',
        name: '自定义',
        x: 0,
        y: 420,
        html: `<i style="font-size:60px;color:skyblue;" class="icon iconfont icon-wenjianjia"></i>`
      }

    ],
    graph_data_links: [
      // { from: '1', to: '2' },
      // { from: '1', to: '3' },
      // { from: '1', to: '5' },
      // { from: '2', to: '4' },
      // { from: '3', to: '4' },
    ],

    // 全部节点信息 没有为null，有为空数组
    nodesList: null,
    // 选中的id
    checkedid: null,

    /*
          这些数据通过脚本参数管理进行配置
          */
    cdnVendor: [],
    //    DB 数据库类型
    dbType: [],
    //    SLB-负载均衡方式
    slbMethod: [],
    //    本地WAF-防护策略
    localWafProtectionStrategy: [],
    //    本地WAF-调度算法
    localWafSchedule: [],
    //    本地WAF-响应方式
    localWafResponseMethod: [],
    //    阿里云WAF-接入模式
    aliWafMode: [],
    /*
        以下数据前端写死，用于应用配置下拉
        */

    cdnOption: {
      // 状态
      StatusOptions: [
        {label: '已开启', value: '已开启'},
        {label: '停用', value: '停用'}

      ],
      // 源站类型
      TypeOptions: [
        {label: '源站IP', value: '源站IP'},
        {label: '源站域名', value: '源站域名'}
      ],
      // 回源协议
      agreenmentOptions: [
        {label: 'http', value: 'http'},
        {label: 'https', value: 'https'}
      ]
    },
    WAF_local: {
      pointStatus_Options: [
        {label: '启用', value: '启用'},
        {label: '未启用', value: '未启用'}
      ],
      responseWay_Options: [
        {label: '转发到业务服务器', value: '转发到业务服务器'},
        {label: '重定向', value: '重定向'},
        {label: '响应指定内容', value: '响应指定内容'}
      ],
      algorithm_Options: [
        {label: '加权轮询法', value: '加权轮询法'},
        {label: '最小连接数法', value: '最小连接数法'},
        {label: '源地址哈希法', value: '源地址哈希法'}
      ],
      monitoring_Options: [
        {label: '启用', value: '启用'},
        {label: '未启用', value: '未启用'}
      ],
      restrictAccess_options: [
        {label: '是', value: '是'},
        {label: '否', value: '否'}
      ],
      strategy_Options: [
        {label: '高防模式', value: '高防模式'},
        {label: '不使用防护策略', value: '不使用防护策略'},
        {label: '默认防护策略', value: '默认防护策略'},
        {label: '观察模式', value: '观察模式'},
        {label: '金融类客户', value: '金融类客户'},
        {label: '互联网客户', value: '互联网客户'},
        {label: '文件上传宽松模式', value: '文件上传宽松模式'},
        {label: '测试策略', value: '测试策略'}
      ]
    },
    WAF_ali: {
      networkAddress: [
        {label: 'IP地址', value: 'IP地址'},
        {label: '域名', value: '域名'}
      ]
    },
    slb_Options: {
      // 协议
      agreenment: [
        {label: 'tcp', value: 'tcp'},
        {label: 'udp', value: 'udp'},
        {label: 'http', value: 'http'},
        {label: 'https', value: 'https'}
      ],
      // 会话
      sessions: [
        {label: '开启', value: '开启'},
        {label: '关闭', value: '关闭'}
      ],
      // 访问控制
      accessControl: [
        {label: '开启', value: '开启'},
        {label: '关闭', value: '关闭'}
      ]

    }
  },
  mutations: {
    addgraph_point (state, value) {
      state.graph_data_nodes.push(value)
    },
    delectgraph_point (state, value) {
      state.graph_data_nodes = state.graph_data_nodes.filter((item, index) => {
        if (item.id === value) {

        } else {
          return item
        }
      })
      state.graph_data_links = state.graph_data_links.filter((item, index) => {
        if (item.from === value || item.to === value) {
          // this.graph_data.links.splice(index,1)
        } else {
          return item
        }
      })
    },
    addgraph_lines (state, value) {
      state.graph_data_links.push(value)
    },
    delectgraph_lines (state, value) {
      state.graph_data_links.forEach((item, index) => {
        if (common.verifyArray(item, value)) {
          state.graph_data_links.splice(index, 1)
        }
      })
    },
    amendOptions (state, value) {
      state[value.key] = value.value
    },
    // 获取全部节点的信息
    getAllNodes (state, value) {
      state.nodesList = value
    },
    // 获取选中节点的id
    getcheckedid (state, value) {
      state.checkedid = value
    }

  },
  actions: {}

}



// WEBPACK FOOTER //
// ./src/store/modules/graph.js